export default __webpack_public_path__ + "static/media/Padsoles of Dark Malice.a9f49772.jpg";